import { STATES, type StateId } from "../lib/states";

interface Props {
  current: StateId;
  onPick: (id: StateId) => void;
}

/**
 * Design-review surface, rendered only with `?states=1`. Freezes live widget
 * callbacks so a state under review is not overwritten mid-inspection.
 */
export default function StateInspector({ current, onPick }: Props) {
  return (
    <aside className="inspector" aria-label="State inspector">
      <div className="inspector__head">
        <p className="eyebrow">States</p>
        <button
          type="button"
          className="btn btn--ghost"
          onClick={() => {
            const root = document.documentElement;
            root.dataset.theme = root.dataset.theme === "dark" ? "light" : "dark";
          }}
        >
          Flip theme
        </button>
      </div>
      <div className="inspector__grid">
        {STATES.map((s) => (
          <button
            key={s.id}
            type="button"
            className="inspector__btn"
            data-state={s.id}
            aria-pressed={s.id === current}
            title={s.trigger}
            onClick={() => onPick(s.id)}
          >
            <span className="inspector__n">{String(s.n).padStart(2, "0")}</span>
            {s.title}
          </button>
        ))}
      </div>
    </aside>
  );
}
